<template>
  <div>
    <div class="login-area flex-center-center">
      <div style="width: 1200px" class="flex-center-end">
        <div class="username">
          <div class="username-title pt5">账号登录</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
            class="demo-ruleForm flex-dir-center">
            <el-form-item prop="username">
              <el-input v-model="ruleForm.username" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="ruleForm.password" show-password placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item class="verify-item" prop="code">
              <el-input style="width: 225px; margin-right: 10px; margin-bottom: 10px" v-model="ruleForm.code"
                placeholder="请输入验证码"></el-input>
              <!-- 验证码图片 -->
              <div v-loading="imgLoading">
                <img @click="getCapt" :src="capUrl" style="width: 120px; height: 38px; border-radius: 3px" alt />
              </div>

              <!-- <div id="v_container" style="width: 120px; height: 48px"></div> -->
            </el-form-item>
            <el-form-item>
              <el-button class="username-button" type="primary" @click="submitForm('ruleForm')">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="flex-center-center pb20 fz14">
            <div class="pointer" @click="handleRetrievePassword">找回密码</div>
<!--            <div class="split-line ml5 mr5"></div>-->
<!--            <div class="fc-407FFF pointer" @click="handleApplyOnline">在线申领</div>-->
          </div>
        </div>
      </div>
    </div>
    <changeAccount ref="changeRef"></changeAccount>
  </div>
</template>
<script>
import {GVerify} from "@/utils/verify.js";
import changeAccount from '../components/ChangeAccount.vue'

export default {
  components: { changeAccount },
  data() {
    return {
      ruleForm: {
        username: '',
        password: '',
        code: undefined,
      },
      code: null,
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      capUrl: "",
      imgLoading: false,
    };
  },
  mounted() {
    // this.show();
    this.getCapt();

    let json = JSON.stringify({code : 100})
    console.log(json)

  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.code = new GVerify("v_container");
      });
    },
    getCapt() {
      this.imgLoading = true;
      this.$http.get(this.$api.login.captchaImage).then((res) => {
        if (res.data.code == 200) {
          this.capUrl = "data:image/jpeg;base64," + res.data.img;
          this.ruleForm.uuid = res.data.uuid;
        }
        this.imgLoading = false;
      });
    },
    //登录的时候判断，是否存在企业账号，如果存在，弹出弹窗选择是否登录企业账号，然后这一步需要保存userId和userInfo
    //userInfo用于用户中心展示信息，userId用于申领账号
    submitForm() {
      this.$refs.ruleForm.validate(async (value) => {
        if (value) {
          this.$http.post(this.$api.customerEnterprise.login, this.ruleForm).then((res) => {
            if (res.data.code == 200) {
                this.$auth.setKqToken(res.data.data.token);
                this.$auth.setKqAccount(JSON.stringify(res.data.data.deptList))
                // this.$router.push({
                //   path: "/customerEnterprise/home",
                // });
                this.$nextTick(() => {
                  this.$refs.changeRef.show('选择登录账号')
                })
            } else {
              this.$message.error(res.data.msg);
            }
            this.getCapt();
          });
        }
      });
    },
      handleRetrievePassword() {
          this.$router.push({
              path: "/customerEnterprise/findPassword",
          });
      },
      handleApplyOnline() {
          this.$router.push({
              path: "/register/register",
          });
      },
      getInfo(type) {
          this.$http.get(this.$api.user.getInfo).then(res => {
              //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
              let temp = res.data.data
              if (type == 'personal') {
                  temp.type = 1
              } else {
                  temp.type = 2
              }

              this.$store.commit("account/setUser", temp);
              this.$router.push({
                  path: "/home",
              });
          })
      },
  },
};
</script>
<style lang="less" scoped>
.login-area {
    width: 100%;
    height: calc(100vh - 104px);
    background: url("~@/assets/login/login-bg2.png") no-repeat, linear-gradient(to right, #07297c, #152254);
    background-position: left center;
    background-size: 100%;

    .username {
        width: 425px;
        border-radius: 6px;
        box-shadow: 0px 1px 6px 1px #0000002b;
        background: url("~@/assets/login/login-right.png") no-repeat #fff;
        background-position: top right;
        background-size: 150px 120px;
        padding: 10px 0;

        .username-title {
            height: 60px;
            line-height: 60px;
            color: #407fff;
            font-size: 20px;
            text-align: center;
            margin-bottom: 30px;
            border-bottom: 1px solid #e5e5e5;
        }

    .username-button {
      width: 350px;
      height: 44px !important;
      opacity: 1;
      color: #ffffff;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
    }

    .split-line {
      width: 1px;
      height: 16px;
      background: #e5e5e5;
    }
  }
}

::v-deep .el-form-item__content {
  width: 350px !important;
}

.verify-item {
  ::v-deep .el-form-item__content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}

::v-deep .el-loading-spinner .circular {
  width: 20px;
  height: 20px;
}
</style>
